import { gql } from '@apollo/client'

import { editFragment } from 'js/magazine-issue/lib/articleFragments'

export const GET_ARTICLE_EDIT = gql`
    query MagazineArticleEdit($containerGuid: String!, $guid: String!) {
        site {
            guid
            maxCharactersInAbstract
        }
        viewer {
            guid
            canInsertMedia(subtype: "blog")
        }
        container: entity(guid: $containerGuid) {
            guid
            ... on MagazineIssue {
                canEdit
            }
        }
        entity(guid: $guid) {
            guid
            ${editFragment}
        }
    }
`
